import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useConsentReady } from "@/contexts/CookieConsentContext";

const GA_ID = "G-036MEF35XZ";

export function GoogleAnalytics() {
  const isAnalyticsAllowed = useConsentReady("analytics");
  const injectedRef = useRef(false);
  const location = useLocation();

  useEffect(() => {
    if (!isAnalyticsAllowed || injectedRef.current) return;
    injectedRef.current = true;

    // Load gtag.js script
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);

    // Initialize dataLayer and gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: unknown[]) {
      window.dataLayer!.push(args);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA_ID);
  }, [isAnalyticsAllowed]);

  // Track route changes
  useEffect(() => {
    if (!isAnalyticsAllowed || !injectedRef.current || !window.gtag) return;
    window.gtag("config", GA_ID, { page_path: location.pathname });
  }, [location.pathname, isAnalyticsAllowed]);

  return null;
}

declare global {
  interface Window {
    dataLayer?: unknown[][];
    gtag?: (...args: unknown[]) => void;
  }
}
